/**
 * TanStack Query hooks for `igaming-negative-carryover-toggle`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	igamingNegativeCarryoverToggleQueryKeys,
	type CreateIgamingNegativeCarryoverToggleBody,
	type ListIgamingNegativeCarryoverToggleResponse,
	type IgamingNegativeCarryoverToggleRow,
} from "./api";

export function useIgamingNegativeCarryoverToggleList(): UseQueryResult<ListIgamingNegativeCarryoverToggleResponse, Error> {
	return useQuery({
		queryKey: igamingNegativeCarryoverToggleQueryKeys.list(),
		queryFn: list,
	});
}

export function useIgamingNegativeCarryoverToggleCreate(): UseMutationResult<IgamingNegativeCarryoverToggleRow, Error, CreateIgamingNegativeCarryoverToggleBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingNegativeCarryoverToggleQueryKeys.all });
		},
	});
}

export function useIgamingNegativeCarryoverToggleDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingNegativeCarryoverToggleQueryKeys.all });
		},
	});
}
